export default __webpack_public_path__ + "static/media/about_point_one.c6b5f97a.svg";